import React, { useEffect, useState } from 'react'
import SettingsMenu from '../../staticscreens/SettingsMenu'
import { useNavigate, useParams } from 'react-router-dom';
import { ButtonFilledAutoWidth } from '../../../components/button';
import { TextAreaInput1, TextInput } from '../../../components/input';
import FileDownloadCard from '../../../components/FileDownloadCard';

function WatiTemplateDetail() {
  
  const { type } = useParams();

  const [data,setdata] = useState({name:'',message:'',file:'',activate:false})
  const [error,seterror] = useState({name:'',message:'',file:''})


  const videoUrl = 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4'
  const imgUrl = 'https://picsum.photos/200/300'
  const docUrl = 'https://morth.nic.in/sites/default/files/dd12-13_0.pdf'

  useEffect(()=>{
    if(type === 'template_send_image'){
      setdata({...data,file:imgUrl})
    }
    if(type === 'template_send_video'){
      setdata({...data,file:videoUrl})
    }
    if(type === 'template_send_document'){
      setdata({...data,file:docUrl})
    }
  },[type])
  
  function generateValue(){
    if(!data.name){
      seterror({...error,name:'This Field is required!'})
    }else if(!['finalning']?.includes(type) && !data.message){
      seterror({...error,message:'This Field is required!'})
    }else{
      setdata({...data,activate:true})
    }
     
  }

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value,activate:false})
    seterror({...error,[e.target.name]:''})
  }




  
  return (
     <div className='md:h-screen pt-5 md:pt-0 md:max-h-screen box-border md:overflow-hidden'>
        <div className='block sm:flex'>
        <SettingsMenu />

        <div className='md:w-[88%] px-4'>
        <div >
            <div className='pt-5'>
                <div  className="flex justify-between align-center items-center border-b pb-2 ">
                <span className="font-[800] text-[14px]">Wati's Template - {type} </span>
                </div>
            </div>

            <div className='flex '>
            <div className='sm:w-full lg:w-72 pr-4 border-r pt-5'>

             {['template_send_image','template_send_video','template_send_document'].includes(type) &&
              <TextInput 
                  label={'File'}  
                  variant="standard"
                  name="file"
                  type="text"
                  error={error.file}
                  value={data.file}
                  handlechange={handlechange}
                  placeholder="Enter your Designation name"
                  InputLabelProps={{
                      style: { color: '#fff', }, 
                  }}/>}

               <TextInput 
                  label={'Name'}  
                  variant="standard"
                  name="name"
                  type="text"
                  error={error.name}
                  value={data.name}
                  handlechange={handlechange}
                  placeholder="Enter your Designation name"
                  InputLabelProps={{
                      style: { color: '#fff', }, 
                  }}/>
      
                {!['finalning']?.includes(type) &&
                <TextAreaInput1 
                  label={'Message'}  
                  variant="standard"
                  name="message"
                  type="text"
                  error={error.message}
                  value={data.message}
                  handlechange={handlechange}
                  placeholder=""
                  InputLabelProps={{
                      style: { color: '#fff', }, 
                  }}/>}
      

              <div className='mt-2'>
              <ButtonFilledAutoWidth btnName="Preview" onClick={generateValue} />
              </div>  
            </div>
            
            {data?.activate &&
            <div className='ml-2'> 
            {type == 'template_send_video' &&
            <>
            <div className='mt-2'>
              <div className='w-[230px]  p-2 border rounded'>
                <video controls src={data?.file}></video>
  
                <h6 className='text-[12px] mt-1'>Hi {data?.name}, please find the attached video. {data?.message}</h6>
              </div>
            </div>
            </>}

            {type == 'template_send_image' &&
            <>
            <div className='mt-2'>
              <div className='w-[230px]  p-2 border rounded'>
                <img src={data?.file} className='w-[100%] h-[170px] object-cover' />
  
                <h6 className='text-[12px] mt-1'>Hi {data?.name}, please find the attached video. {data?.message}</h6>
              </div>
            </div>
            </>}

            {type == 'template_send_document' &&
            <>
            <div className='mt-2'>
              <div className='w-[300px]  p-2 border rounded'>
                <FileDownloadCard fileName={'Document'} downloadUrl={data?.file}  />
                <h6 className='text-[12px] mt-1'>Hi {data?.name}, please find the attached video. {data?.message}</h6>
              </div>
            </div>
            </>}

            {type == 'reply_message_main' &&
            <>
            <div className='mt-2'>
              <div className='w-[300px]  p-2 border rounded'>
                <h6 className='text-[12px] mt-1'>Hi {data?.name}</h6>
                <h6 className='text-[12px] mt-1'>For your Info : {data?.message}</h6>
              </div>
            </div>
            </>}

 

 
           {type == 'reply_message1' &&
            <>
            <div className='mt-2'>
              <div className='w-[300px]  p-2 border rounded'>
                <h6 className='text-[12px] mt-1'>Hi {data?.name}</h6>
                <h6 className='text-[12px] mt-1'>{data?.message}</h6>
                <h6 className='text-[12px] mt-2'>Best regards, </h6>
                <h6 className='text-[12px] mt-1'>Your Company Team</h6>
              </div>
            </div>
            </>}

            {type == 'finalning' &&
            <>
            <div className='mt-2 w-[240px]'>
            <video width="240" height="460" controls preload="metadata">
            <source 
              src={'https://myleadsconsolebucket.s3.ap-south-1.amazonaws.com/leads_console/Ning.mp4'}
              type="video/mp4" />
            </video>
              <h6 className='text-[12px] mt-1'>Welcome to My Academy Partner {data?.name} – Where Smart Parents and Students Begin Their Smart Learning Journey!</h6>
            </div>
            </>}


      

            </div>} 
            </div>
            
          


        </div>
        </div>
        </div>  

     </div>   
  )
}

export default WatiTemplateDetail